import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    api
      .post("/auth/google/session", { session_id })
      .then((res) => {
        setUser(res.data.user);
        // strip the hash from the URL
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        navigate("/login?err=1", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
      <div className="text-neutral-500 text-sm font-mono">Establishing session…</div>
    </div>
  );
}
